var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2906 16.779C20.2906 16.4367 20.1546 16.1084 19.9126 15.8663C19.6705 15.6243 19.3422 15.4883 18.9999 15.4883C18.6576 15.4883 18.3293 15.6243 18.0873 15.8663C17.8452 16.1084 17.7092 16.4367 17.7092 16.779V27.1046C17.7092 27.4469 17.8452 27.7752 18.0873 28.0172C18.3293 28.2593 18.6576 28.3953 18.9999 28.3953C19.3422 28.3953 19.6705 28.2593 19.9126 28.0172C20.1546 27.7752 20.2906 27.4469 20.2906 27.1046V16.779Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0C8.78284 0 0.5 8.28284 0.5 18.5C0.5 28.7172 8.78284 37 19 37C29.2172 37 37.5 28.7172 37.5 18.5C37.5 8.28284 29.2172 0 19 0ZM3.0814 18.5C3.0814 14.2781 4.75853 10.2292 7.74385 7.24385C10.7292 4.25853 14.7781 2.5814 19 2.5814C23.2219 2.5814 27.2708 4.25853 30.2562 7.24385C33.2415 10.2292 34.9186 14.2781 34.9186 18.5C34.9186 22.7219 33.2415 26.7708 30.2562 29.7562C27.2708 32.7415 23.2219 34.4186 19 34.4186C14.7781 34.4186 10.7292 32.7415 7.74385 29.7562C4.75853 26.7708 3.0814 22.7219 3.0814 18.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7209 11.6164C20.7209 12.0729 20.5396 12.5106 20.2169 12.8333C19.8941 13.1561 19.4564 13.3374 19 13.3374C18.5436 13.3374 18.1058 13.1561 17.7831 12.8333C17.4604 12.5106 17.2791 12.0729 17.2791 11.6164C17.2791 11.16 17.4604 10.7223 17.7831 10.3996C18.1058 10.0768 18.5436 9.89551 19 9.89551C19.4564 9.89551 19.8941 10.0768 20.2169 10.3996C20.5396 10.7223 20.7209 11.16 20.7209 11.6164Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestInfo);
export default __webpack_public_path__ + "static/media/rest_info.7b2dc709e15e52171047fcf5f05d92b0.svg";
export { ForwardRef as ReactComponent };